import ms from 'ms';

export const RECOMMENDED_SIMILAR_ITEMS_CACHE_TIME = ms('30m');
export const RECOMMENDED_SIMILAR_ITEMS_LIMIT = 32;
export const RECOMMENDED_SIMILAR_ITEMS_CAROUSEL_LIMIT = 16;
export const RECOMMENDED_SIMILAR_ITEMS_SAVED_LOOKBACK_TIME = ms('30d');
export const RECOMMENDED_SIMILAR_ITEMS_SEED_LIMIT = 2;

export type FetchRecommendedSimilarItemsRequest = {
    forceUpdate?: boolean;
    shouldUseLastTwoSavedLots?: boolean;
    shouldUseLastTwoViewedLots?: boolean;
    skipSavedItemsFetch?: boolean;
};

export type FetchRecommendedSimilarItemsPayload = {
    actionTime: number;
    itemIds: number[];
    seedItemIds: number[];
};

export type RecommendedSimilarItemsSlice = {
    itemIds: number[];
    loaded: number;
    loading: boolean;
    seedItemIds: number[];
};

export const defaultRecommendedSimilarItemsSlice: RecommendedSimilarItemsSlice = {
    itemIds: [],
    loaded: 0,
    loading: false,
    seedItemIds: [],
};
